import { useEffect, useRef } from 'react'

/** Столько держим сообщение на экране — прочитать успевают, мешать не успевает. */
const HIDE_MS = 4000

interface Props {
  text: string | null
  onHide: () => void
}

/**
 * Ответ на действие показываем поверх экрана, а не в конце страницы.
 *
 * Кнопки «Скопировать» и «Отправить» живут в середине длинной страницы, и
 * сообщение в самом низу ребёнок просто не видит: кажется, что нажатие ничего
 * не сделало. Особенно заметно там, где системного «Поделиться» нет и всё, что
 * мы можем, — это сказать словами, что произошло.
 */
export default function Toast({ text, onHide }: Props) {
  const hide = useRef(onHide)
  hide.current = onHide

  useEffect(() => {
    if (!text) return

    const timer = setTimeout(() => hide.current(), HIDE_MS)

    return () => clearTimeout(timer)
  }, [text])

  if (!text) {
    return null
  }

  return (
    <button type="button" className="toast" onClick={onHide}>
      {text}
    </button>
  )
}
